// @flow
import {
    ATTEMPT_CREATE_RECIPE,
    ATTEMPT_DELETE_RECIPE,
    ATTEMPT_UPDATE_RECIPE,
    CANCEL_ACTION,
    CANCEL_TEMPLATE,
    EDIT_RECIPE,
    EDIT_SCHEDULE,
    GET_RECIPES,
    HANDLE_NOTIFICATION_CHANGE,
    HANDLE_PROPERTY_CHANGE,
    HIDE_MODAL,
    RECEIVE_RECIPES,
    REQUEST_CONFIRM_DELETE,
    SELECT_CONSUMER,
    SELECT_PRODUCER,
    SELECT_TEMPLATE,
    SHOW_TEMPLATES_LIST,
    TOGGLE_SCHEDULE_STATE,
    UPDATE_DATA,
    UPDATE_RECIPE
} from './constants';

import { createAction } from 'redux-actions';

export const attemptCreateRecipe = createAction(ATTEMPT_CREATE_RECIPE);
export const attemptDeleteRecipe = createAction(ATTEMPT_DELETE_RECIPE);
export const attemptUpdateRecipe = createAction(ATTEMPT_UPDATE_RECIPE);
export const cancelAction = createAction(CANCEL_ACTION);
export const cancelTemplate = createAction(CANCEL_TEMPLATE);
export const editRecipe = createAction(EDIT_RECIPE);
export const editSchedule = createAction(EDIT_SCHEDULE);
export const getRecipes = createAction(GET_RECIPES);
export const handleNotificationChange = createAction(HANDLE_NOTIFICATION_CHANGE);
export const handlePropertyChange = createAction(HANDLE_PROPERTY_CHANGE);
export const hideModal = createAction(HIDE_MODAL);
export const receiveRecipes = createAction(RECEIVE_RECIPES);
export const requestConfirmDelete = createAction(REQUEST_CONFIRM_DELETE);
export const selectConsumer = createAction(SELECT_CONSUMER);
export const selectProducer = createAction(SELECT_PRODUCER);
export const selectTemplate = createAction(SELECT_TEMPLATE);
export const showTemplateList = createAction(SHOW_TEMPLATES_LIST);
export const toggleScheduleState = createAction(TOGGLE_SCHEDULE_STATE);
export const updateData = createAction(UPDATE_DATA);
export const updateRecipe = createAction(UPDATE_RECIPE);



// WEBPACK FOOTER //
// ./src/core/state/recipes/actions.js